/**
 * `?series=<seriesPublicId>` (FI-593, round 37 `1a` A7): "Write a new post" from a series lands on a fresh
 * composer with that series already selected as a publish target. An INSTRUCTION, not a state, so the
 * composer consumes it once (`consume-one-shot`, rule 33). Design:
 * `designs/04-live/2026-05-19-discussion-publish-group-and-series-targeting-design.md` §Status.
 */
export const SERIES_PREFILL_QUERY_PARAM = "series";

/** The series dialog's "Write a new post" destination: always a NEW draft, never the reused empty one. */
export function buildNewPostInSeriesUrl(seriesPublicId: string): string {
    return `/create/discussion/new?${SERIES_PREFILL_QUERY_PARAM}=${encodeURIComponent(seriesPublicId)}`;
}

/** The series public id the address asks for, or `null`. A blank value is no request. */
export function readSeriesPrefillRequest(search: string): string | null {
    const value = new URLSearchParams(search).get(SERIES_PREFILL_QUERY_PARAM);
    return value && value.trim() ? value.trim() : null;
}

/** The same address with the instruction removed (path, remaining query, hash), for the consuming replace. */
export function stripSeriesPrefillRequest(href: string): string {
    const url = new URL(href, "http://localhost");
    url.searchParams.delete(SERIES_PREFILL_QUERY_PARAM);
    return `${url.pathname}${url.search}${url.hash}`;
}
